import { render, staticRenderFns } from "./index.vue?vue&type=template&id=195ed323&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SearchTriggerCondensed: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/SearchTrigger/SearchTriggerCondensed.vue').default,SearchModal: require('/home/runner/work/api-docs-frontend/api-docs-frontend/components/global/SearchModal/index.vue').default})
